import React from 'react';
import { useTranslation } from 'react-i18next';

// Import components
import CommonButton from './CommonButton';

// Import styles
import { IconFavorite } from './styles';

const FavouriteButton = () => {
	const { t } = useTranslation();

	return (
		<CommonButton>
			<IconFavorite />
			{t('product_preview:buttons.vod_buttons_favourite_add')}
		</CommonButton>
	);
};

export default FavouriteButton;
